<template>
  <div class="main-container">
    <tl-header type="h1">
          <div class="main-header">Please Select Month and Year:</div>
    </tl-header>
    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />    
    <div class="payslipMain">
      <!-- <div class="payslipContainer">
        <VueSlickCarousel v-bind="settings" class="VueSlickCarousel">
            <div  :class="isActive == item ? 'Payslipactive': 'wrapperDiv'" v-for="item in dropDown" @click="myFilter(item)">
            <span>{{(item.month +" "+ item.year)}}</span>
          </div>
        </VueSlickCarousel>
      </div> -->
      <div class="product-carousellll">
            <div class="pre-btn" @click="btnpressprev()">&lt;</div>
            <div class="next-btn" @click="btnpressnext()">&gt;</div>
            <div class="productDivvvv" >
              <div v-for="(item, index) in monthOptions" :key="index">
                <div :class="isActive == item ? 'Payslipactive': 'mycard'" @click="myFilter(item)">{{(item)}}</div>
              </div> 
            </div>
        </div>
      <div class="searchContainer">
        <tl-select class="searchDiv" :options="monthOptions" placeholder="Year/Month" v-model="month" @change="(val)=> month = val"/>
        <img src="@/assets/DownloadEss.svg" class="downloadButton" alt="" @click="downloadEssPayslip()">
      </div>
    </div>
  <div v-html="htmlContent" style="width: 65%;"></div>
  </div>
</template>
<script>
// import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
//   // optional style for arrows & dots
import { mapActions } from 'vuex';
const crypto = require("crypto");

// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  // components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        "arrows": true,
        "centerMode": true,
        "centerPadding": "20px",
        "focusOnSelect": true,
        "infinite": true,
        "slidesToShow": 7,
        "speed": 500
      },
      isActive: false,
      model: null,
      monthOptions: [],
      month: "",
      employeeData: {},
      errmsg: "",
      toast: false,
      newPayslipMonth: null,
      htmlContent: "",
    };
  },

  mounted() {
    this.getEmployeeData();
    this.getPayrollMonths();
  },

  activated() {
    this.getEmployeeData();
    this.getPayrollMonths();
  },

  computed: {
    le_id(){
      return localStorage.getItem("le_id")
    },

    empId(){
      return localStorage.getItem("empId")
    },
  },

  methods: {
    ...mapActions({
      act_getPayrollMonthList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthList',
      act_downloadpayslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      act_download_new_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewPayslips",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    myFilter(value){
      this.isActive = value;
      let box = document.querySelector('.productDivvvv');
      this.month = value;
      this.downloadHTMLPayslip();      //let width = (box.clientWidth)/2;
      //box.scrollLeft = box.scrollLeft + width;
    },

   btnpressprev(){
    let box = document.querySelector('.productDivvvv');
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft - width;
    },

     btnpressnext () {
      let box = document.querySelector('.productDivvvv');
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft + width;
    },

    async getEmployeeData() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;
        let obj = {
          'employee_id': this.employee_id
        };
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        this.employeeData.dob = new Date(this.employeeData.dob).toISOString().slice(0, 10);
        this.employeeData.date_of_joining = (new Date(this.employeeData.date_of_joining).toLocaleString().slice(0, 10)).split("/").join("-");
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getPayrollMonths() {
      try {
        let obj ={
          emp_id : this.empId,
          le_id: this.le_id
        }
        let payrollMonths = [];
        let months = [];
        let res = await this.act_getPayrollMonthList(obj);
        if(res.data && res.data.payload){
          res.data.payload.payload.data.length && res.data.payload.payload.data.map(element => {
            months = Object.keys(element.masterSal);
            months.map(item => {
              item = `${item}-${element.FY}`;
              payrollMonths.push(item);
            });
          })
          this.monthOptions = payrollMonths;
          this.month = this.monthOptions[this.monthOptions.length - 1];
          this.monthOptions = payrollMonths.reverse();
          this.isActive = this.month;
          await this.getEmployeeData();
          await this.downloadHTMLPayslip();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      }
    },

    async downloadEssPayslip() {
      try {
        let month = this.month.split("-")[0];
        this.getMonthName(month);
        let obj = {
          empCode: this.employeeData.code, // PL_3042
          payMonth: this.newPayslipMonth, // PL_3042
          clientName: this.employeeData.first_name,
          reportType: "pdf",
          paymentYear: this.month.split("-")[1],
          clientCode: this.employeeData.legalEntityDetails.clientCode,
          legalEntityId: this.employeeData.legal_entity_id
        }
        let data = await this.encryptData(obj);
        let res = await this.act_download_new_payslip(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data.data));
        const url = apiResponse[0].pdfPreSignedUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Payslip.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

  async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        console.log(err)
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {
        // console.log(error)
      }
    },

    async downloadHTMLPayslip() {
      try {
        this.htmlContent = "";
        let month = this.month.split("-")[0];
        this.getMonthName(month);
        let obj = {
          empCode: this.employeeData.code, // PL_3042
          payMonth: this.newPayslipMonth, // PL_3042
          clientName: this.employeeData.first_name,
          reportType: "pdf",
          paymentYear: this.month.split("-")[1],
          clientCode: this.employeeData.legalEntityDetails.clientCode,
          legalEntityId: this.employeeData.legal_entity_id
        }
        let data = await this.encryptData(obj);
        let res = await this.act_download_new_payslip(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data.data));
        // Define the string
        this.toast = false;
        let encodedStringAtoB = apiResponse[0].htmlPreSignedUrl;
        // Decode the String
        let decodedStringAtoB = Buffer.from(encodedStringAtoB, 'base64').toString('UTF-8');
        this.htmlContent = decodedStringAtoB.replaceAll("b9", "₹");
      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },
  }
};
</script>
<style lang="scss" scoped>
 //margins

/* .mainHeading {
  font-weight:550;
  color:rgba(18, 18, 20,0.690);
  font-style:inherit
} */

.main-header{
  font-weight: bold;
  color: #777777;
}

.payslipMain{
  display: flex;
  justify-content: space-between;
}
.payslipContainer{
  width: 55%;
  padding:20px 40px;
}

.payslipContainer > button {
  color: pink;
}




.wrapper {
  width: 100%;
  display: flex;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;
  align-items: center;
  gap: 20px;
  scroll-snap-type: inline mandatory;
  scroll-padding-inline: 20px;
}

.wrapper > * {
  scroll-snap-align: start;

}

.wrapper::-webkit-scrollbar{
  display: none;
}

.wrapperDiv{
  min-width: 100px;
  padding: 10px 15px;
  background-color: transparent;
  border-radius: 25px;
  font-weight: bold;
  text-align: center;
  color: #777777;
  border: 1px solid #376cd3;
  cursor: pointer;
}



.carousel-3d-controls, .prev, .next {
  color: black;
}

.searchContainer{
  display: flex;
  align-items: flex-end;
  width: 25%;
  padding: 30px;
}

.searchContainer > * {
  margin-right: 20px;
}

.searchDiv{
  width: 200px;
  text-transform: capitalize;
}

.downloadButton{
  height: 35px;
  width: 35px;
  cursor: pointer;
}

.searchContainerSvg{
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.product-carousellll {
  width: 80%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 26px 48px;
}

.productDivvvv {
    /* padding: 0 15px; */
    display: flex;
    width: 100%;
    justify-content: flex-start;
    overflow: hidden;
    overflow-x: scroll;
    align-items: center;
    scroll-behavior: smooth;
    gap: 10px;
    scroll-snap-type: inline mandatory;
}

.productDivvvv > *{
  scroll-snap-align: start;
}

.productDivvvv::-webkit-scrollbar{
  display: none;
}

.pre-btn,
.next-btn {
    border: none;
    width: 60px;
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    font-size: 2rem;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
}

.pre-btn {
    left: -10px;
}

.next-btn {
    right: -10px;
}

.next-btn p,
.pre-btn p {
    font-size: 35px;
    /* background-color: rgba(255, 255, 255, 0.436);
    box-shadow: 0px 0px 10px 1px black;
    border-radius: 10px; */
    color: rgba(0, 0, 0, 0.381);
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    width: 50px;
    height: 50px;
    cursor: pointer;
}

.mycard {
    /* max-width: 300px; */

  /* min-width: 150px; */
  padding: 8px 30px;
  white-space: nowrap;
  background-color: transparent;
  border-radius: 25px;
  font-weight: bold;
  text-align: center;
  color: #777777;
  font-size: 0.9rem;
  border: 1px solid #376cd3;
  cursor: pointer;
  text-transform: capitalize;
}

.Payslipactive{
  /* min-width: 150px; */
  padding: 8px 30px;
  white-space: nowrap;
  background-color: #376cd3;
  color: #ffffff;
  border-radius: 25px;
  text-align: center;
  font-weight: bold;
  font-size: 0.9rem;
  border: 1px solid #376cd3;
  cursor: pointer;
  text-transform: capitalize;
}

</style>
